import React, { FC, useState, useRef, useEffect } from 'react';

import { Typography } from '@mui/material';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { CardLabels } from '../../../../components/Card';
import { CategoryLabel } from '../../../../components/UI/CategoryLabel';
import { colorsPalette } from '../../../../theme';
import { DEFAULT_URL } from '../../const';
import useStyles from './styles';

interface GlossaryGridHitProps {
  slug: string;
  title: string;
  description: string;
  categories?: [any];
  videoUrl?: string;
}

const GlossaryGridHit: FC<GlossaryGridHitProps> = ({
  slug,
  title,
  description,
  categories,
  videoUrl,
}) => {
  const { t } = useTranslation();
  const [descriptionLines, setDescriptionLines] = useState(2);

  const blockRef = useRef<HTMLDivElement>(null);

  const classes = useStyles(descriptionLines)();

  useEffect(() => {
    if (blockRef.current?.clientHeight) {
      const lines = Math.floor((blockRef.current.clientHeight - 42) / 23);
      setDescriptionLines(lines);
    }
  }, [description, title]);

  return (
    <div className={classes.wrapper}>
      <CardLabels>
        <CategoryLabel
          key={videoUrl}
          wrapperClass={classes.cardLabel}
          name={t('page.discover.glossary')}
          textColor={colorsPalette.white}
          bgColor={colorsPalette.coral}
        />
        {categories && categories?.[0] && (
          <CategoryLabel
            wrapperClass={cn(classes.cardLabel, classes.categoryLabel)}
            key={categories?.[0]?.id}
            name={categories?.[0]?.title}
            withDots
          />
        )}
        {!!videoUrl && (
          <CategoryLabel
            key={videoUrl}
            wrapperClass={classes.cardLabel}
            name={t('page.discover.videoClip')}
            textColor={colorsPalette.blueDark}
            bgColor={colorsPalette.yellow}
          />
        )}
      </CardLabels>
      <Typography className={classes.title} variant="h3">
        {title}
      </Typography>
      <div className={classes.infoWrapper} ref={blockRef}>
        <Typography className={cn(classes.description)}>{description}</Typography>
        <Link className={classes.link} to={`${DEFAULT_URL}/glossary/${slug}`}>
          {t('page.discover.readMore')}
        </Link>
      </div>
    </div>
  );
};

export default GlossaryGridHit;
